import { render, staticRenderFns } from "./clipboard.vue?vue&type=template&id=71fbaf37&scoped=true&lang=pug&"
import script from "./clipboard.vue?vue&type=script&lang=js&"
export * from "./clipboard.vue?vue&type=script&lang=js&"
import style0 from "./clipboard.vue?vue&type=style&index=0&id=71fbaf37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fbaf37",
  null
  
)

export default component.exports